import { GridContainer } from "components/ui/Grid";
import * as _ from "lodash";
import * as React from "react";
import { FiltersBar } from "components/ui/FiltersBar";
import { ContentCardHeader } from "components/ui/ContentCardHeader";
import { FontAwesomeIcon } from "components/ui/FontAwesomeIcon";
import { Popover } from "../../components/ui/Popover";
import { DataGrid, DataGridSortOrder } from "components/ui/DataGrid";
import { getReviews, IReview, updateReview } from "./lib/http";
import { IFilters } from "util/userData";
import { CommentCodeSelect } from "containers/CommentDetails/lib/CommentCodeSelect";
import { Tooltip } from "components/ui/Tooltip";
import { Modal, ModalContent, ModalFooter } from "components/ui/Modal";
import { Alert, Button, FormGroup, Label, Input, ModalHeader, } from 'reactstrap';
import {
  ICommentCodeIndex,
  getCommentCodesByType,
  getCommentCodes,
  ICommentCodesByType,
} from "containers/CommentDetails/lib/http";


interface ISocialMediaDetailsProps {
  filters: IFilters;
}

interface ISocialMediaDetailsState {
  hiddenProperties: Array<keyof IReview>;
  loading: boolean;
  filterText: string;
  actionItemFilter: boolean;
  wowFilter: boolean;
  perfectScoreFilter: boolean;
  salesOpportunityFilter: boolean;
  attritionRiskFilter: boolean;
  isFlaggedFilter: boolean;
  flagEdit: boolean;
  readFilter: boolean;
  sortBy: keyof IReview;
  sortOrder: DataGridSortOrder;
  records: IReview[];
  selectedReviewIds: number[];
  reviewInEditModeId: number;
  reviewInEditMode: IReview;
  modalOpen: boolean;
  stagingCodes: string[];
  toggleEdit: boolean;
  isSubmittingUpdate: boolean;
  allCodes: ICommentCodeIndex[];
  commentCodes: ICommentCodesByType[];
  commentCodesLoaded: boolean;
  commentCodeTabs: string[];
  activeTab: string;
  displayErrorMessage: boolean;
}

export class SocialMediaDetailsContainer extends React.Component<
  ISocialMediaDetailsProps,
  ISocialMediaDetailsState
> {
  static SocialMediaDetailsContainerKey = "SocialMediaDetailsContainerKey";

  state: ISocialMediaDetailsState = {
    loading: false,
    filterText: "",
    actionItemFilter: false,
    wowFilter: false,
    perfectScoreFilter: false,
    salesOpportunityFilter: false,
    attritionRiskFilter: false,
    isFlaggedFilter: false,
    flagEdit: false,
    readFilter: null,
    sortBy: "createTime",
    sortOrder: "asc",
    records: [],
    selectedReviewIds: [],
    reviewInEditModeId: 0,
    reviewInEditMode: null,
    modalOpen: false,
    stagingCodes: [],
    toggleEdit: true,
    isSubmittingUpdate: false,
    displayErrorMessage: false,
    allCodes: [],
    commentCodes: [],
    commentCodesLoaded: false,
    commentCodeTabs: [],
    activeTab: "Customer",
    hiddenProperties: ["locationId"],
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.updateReviews();
    this.loadCommentCodes();
  }

  componentWillReceiveProps(nextProps: ISocialMediaDetailsProps) {
    this.updateReviews(nextProps);
  }

  updateReviews(props = this.props) {
    getReviews(props.filters, false).then((records) => {
      this.setState({ records, loading: false });
    });
  }

  loadCommentCodes() {
    getCommentCodesByType().then((commentCodes) => {
      const tabs = [];
      commentCodes.map((value) => {
        tabs.push(value.typeName);
      });
      this.setState({
        commentCodes,
        commentCodesLoaded: true,
        commentCodeTabs: tabs,
      });
    });

    getCommentCodes(true).then((allCodes) => {
      this.setState({ allCodes });
    });
  }

  renderIdColumn(record: IReview) {
    return (
      <a
        href="javascript:void(0)"
        onClick={() => this.openCoachingForm(record)}
      >
        <FontAwesomeIcon icon="search" verticalAlign="initial" size="md" />
        <span>&nbsp;{record.id}</span>
        <span>
          &nbsp;
          {record.hasComments ? (
            <FontAwesomeIcon
              icon="circle"
              color="orange"
              verticalAlign="initial"
              size="md"
              style={{ fontSize: "12px" }}
            />
          ) : null}
        </span>
      </a>
    );
  }

  render() {
    const { loading, readFilter, records, selectedReviewIds } = this.state;
    const {
      reviewInEditMode,
      toggleEdit,
      isSubmittingUpdate,
      displayErrorMessage,
      activeTab,
    } = this.state;
    const reviewInEditModeId = reviewInEditMode
      ? reviewInEditMode.id
      : undefined;
    const recordsLength = records.length;
    const noneSelected = selectedReviewIds.length === 0;
    const shouldDisableBulkSelectAll = false;
    const selectedLength = selectedReviewIds.length;
    const hasData = !loading && recordsLength > 0;
    const displayMessage = displayErrorMessage ? "" : "none";
    return (
      <>
        <section className="blacklight page-container">
          <section className="containerv2">
            <GridContainer>
              <FiltersBar
                hideHeirarchy
                hideMetrics
                hideQuestions
                hideSearch
                hideSegments
                hideSurveys
                showSocialMediaSource={true}
                showDatePicker={true}
              ></FiltersBar>
              <ContentCardHeader
                sticky
                borderBottom
                header={
                  <section className="d-md-flex justify-content-between">
                    <article>
                      <span>Review Details</span>
                      {loading && (
                        <FontAwesomeIcon
                          icon="cog"
                          size="sm"
                          verticalAlign="middle"
                          spin
                          muted
                        />
                      )}
                      {!noneSelected && (
                        <small>
                          :&nbsp;{selectedLength.toLocaleString()}&nbsp;selected
                        </small>
                      )}
                    </article>
                    <article className="d-md-flex justify-content-end">
                      <Popover btnText="Fields" className="mr-3">
                        <section
                          style={{
                            fontSize: "1rem",
                            minWidth: 150,
                            maxHeight: "250px",
                            overflowY: "scroll",
                          }}
                        >
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("locationId")}
                                onChange={() =>
                                  this.toggleHiddenColumn("locationId")
                                }
                              />
                              <span>&nbsp;Location</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("reviewerName")}
                                onChange={() =>
                                  this.toggleHiddenColumn("reviewerName")
                                }
                              />
                              <span>&nbsp;Reviewer</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("createTime")}
                                onChange={() =>
                                  this.toggleHiddenColumn("createTime")
                                }
                              />
                              <span>&nbsp;Review Date</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("starRating")}
                                onChange={() =>
                                  this.toggleHiddenColumn("starRating")
                                }
                              />
                              <span>&nbsp;Rating</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("commentCodes")}
                                onChange={() =>
                                  this.toggleHiddenColumn("commentCodes")
                                }
                              />
                              <span>&nbsp;Codes</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input
                                type="checkbox"
                                checked={!this.isHiddenColumn("platform")}
                                onChange={() =>
                                  this.toggleHiddenColumn("platform")
                                }
                              />
                              <span>&nbsp;Source</span>
                            </Label>
                          </FormGroup>
                        </section>
                      </Popover>
                    </article>
                  </section>
                }
                headerActions={
                  <section className="mt-2 d-md-flex justify-content-between">
                    <article>
                      <Button
                        className="mr-2"
                        color="primary"
                        disabled={noneSelected}
                        onClick={() => this.exportSelected()}
                      >
                        Export Selected to PDF
                      </Button>
                      <Button
                        className="mr-2"
                        color="primary"
                        disabled={shouldDisableBulkSelectAll}
                        onClick={() => this.selectAllReviews()}
                      >
                        Select All
                      </Button>
                      <Button
                        className="mr-2"
                        color="primary"
                        disabled={noneSelected}
                        onClick={() => this.selectNoneForReviews()}
                      >
                        Clear Selection
                      </Button>
                    </article>
                  </section>
                }
              />
              {hasData && (
                <DataGrid<IReview>
                  className="animated fadeIn"
                  sortBy={this.state.sortBy}
                  sortOrder={this.state.sortOrder}
                  onSortChange={(sortBy, sortOrder) =>
                    this.setState({ sortBy, sortOrder })
                  }
                  records={records}
                  columns={[
                    {
                      header: "",
                      sortable: false,
                      width: 55,
                      render: (record) => this.renderViewedColumn(record),
                    },
                    {
                      header: "Bulk",
                      align: "center",
                      width: 55,
                      sortable: false,
                      render: (avid) => this.renderBulkCheck(avid),
                    },
                    {
                      header: "ID",
                      align: "center",
                      width: 125,
                      render: (record) => this.renderIdColumn(record),
                    },
                    {
                      header: "Reviewer Name",
                      property: "reviewerName",
                      hidden: this.isHiddenColumn("reviewerName"),
                    },
                    { header: "Review", property: "comment", width: 300 },
                    {
                      header: "Codes",
                      property: "commentCodes",
                      width: 300,
                      hidden: this.isHiddenColumn("commentCodes"),
                      render: (record) => {
                        const isInEditMode = record.id === reviewInEditModeId;
                        const codes = isInEditMode
                          ? reviewInEditMode.commentCodes
                          : record.commentCodes;

                        return (
                          <section>
                            <CommentCodeSelect
                              disabled={!isInEditMode}
                              values={codes}
                              onChange={(newCodes) =>
                                this.updateReviewInEditMode(newCodes)
                              }
                            />
                            {isInEditMode ? (
                              <a
                                className="link"
                                style={{ float: "right" }}
                                onClick={() => this.toggleModal()}
                              >
                                Select Comment Codes
                              </a>
                            ) : null}
                          </section>
                        );
                      },
                    },
                    {
                      header: "Location",
                      property: "locationId",
                      hidden: this.isHiddenColumn("locationId"),
                    },
                    {
                      header: "Source",
                      property: "platform",
                      hidden: this.isHiddenColumn("platform"),
                      render: (record) => (
                        <a href={record.reviewUrl} target="_blank">
                          {record.platform}
                        </a>
                      ),
                    },
                    {
                      header: "Star Rating",
                      property: "starRating",
                      width: 225,
                      hidden: this.isHiddenColumn("starRating"),
                      render: (record) => this.renderStars(record),
                    },
                    {
                      header: "Posted",
                      property: "createTime",
                      hidden: this.isHiddenColumn("createTime"),
                    },
                    {
                      sortable: false,
                      header: "",
                      render: (record) => {
                        const { id } = record;
                        const isInEditMode = reviewInEditModeId === id;
                        const idPrefix = `${record.id}-`;
                        const viewBtnId = `${idPrefix}view-btn`;
                        const editBtnId = `${idPrefix}edit-btn`;

                        return (
                          <section className="d-flex justify-content-start align-items-center">
                            <Button
                              color="white"
                              id={viewBtnId}
                              className="ml-2"
                              onClick={() => this.openCoachingForm(record)}
                            >
                              <Tooltip text="View">
                                <FontAwesomeIcon
                                  icon="search"
                                  fixedWidth
                                  size="sm"
                                />
                              </Tooltip>
                            </Button>
                            {isInEditMode && toggleEdit && (
                              <React.Fragment key={id}>
                                <Button
                                  color="success"
                                  className="ml-2"
                                  disabled={isSubmittingUpdate}
                                  onClick={() =>
                                    this.submitReviewForUpdate(record)
                                  }
                                >
                                  <span>Submit&nbsp;</span>
                                  {isSubmittingUpdate && (
                                    <FontAwesomeIcon
                                      icon="sync"
                                      fixedWidth
                                      size="sm"
                                      spin
                                    />
                                  )}
                                  {!isSubmittingUpdate && (
                                    <FontAwesomeIcon
                                      icon="check-circle"
                                      fixedWidth
                                      size="sm"
                                    />
                                  )}
                                </Button>
                                <Button
                                  color="white"
                                  className="ml-2"
                                  disabled={isSubmittingUpdate}
                                  onClick={() => this.setReviewInEditMode(null)}
                                >
                                  <span>Cancel</span>
                                </Button>
                              </React.Fragment>
                            )}
                            {!isInEditMode && toggleEdit && (
                              <>
                                <Button
                                  color="warning"
                                  id={editBtnId}
                                  className="ml-2"
                                  onClick={() =>
                                    this.setReviewInEditMode(record)
                                  }
                                >
                                  <Tooltip text="Edit">
                                    <FontAwesomeIcon
                                      icon="pencil-alt"
                                      fixedWidth
                                      size="sm"
                                    />
                                  </Tooltip>
                                </Button>
                              </>
                            )}
                          </section>
                        );
                      },
                    },
                  ]}
                />
              )}
            </GridContainer>
          </section>
        </section>
        <Modal open={this.state.modalOpen}>
          <ModalHeader style={{ padding: "10px" }}>
            <section
              style={{ padding: "10px 0" }}
              key="chooseCommentCodesTitle"
            >
              Select Up to Six Comment Codes
            </section>
            <section style={{ paddingBottom: "10px", fontSize: "70%" }}>
              Currently Selected:&nbsp;
              {this.state.stagingCodes && (
                <>
                  {this.state.stagingCodes.map((value) => {
                    return (
                      <>
                        {value !== null ? this.drawSelectedCode(value) : null}
                      </>
                    );
                  })}
                </>
              )}
            </section>
            <Alert
              color="danger"
              style={{
                color: "#721c24",
                backgroundColor: "#f8d7da",
                borderColor: "#f5c6cb",
                padding: ".75rem 1.25rem",
                fontSize: "1.0rem",
                display: displayMessage,
              }}
            >
              You’ve reached the maximum 6 codes. Before adding another code,
              you must first remove one of the currently selected codes.{" "}
              <a
                className="link"
                onClick={() => this.closeErrorMessage()}
                style={{ float: "right" }}
              >
                Close
              </a>
            </Alert>
          </ModalHeader>
          <ModalContent style={{ padding: "5px 20px" }}>
            <section>
              {this.state.commentCodesLoaded && (
                <ul
                  className="tabs row"
                  style={{ border: "1px solid rgb(50, 122, 183)" }}
                >
                  {this.state.commentCodeTabs.map((value) => {
                    const href = "#" + value;
                    const activeClass = value === activeTab;
                    const activeStyle = {
                      color: "#fff",
                      backgroundColor: "#327AB7",
                    };
                    const inactiveStyle = {
                      color: "#327AB7",
                      backgroundColor: "#fff",
                    };
                    const style = activeClass ? activeStyle : inactiveStyle;
                    return (
                      <li
                        className="tab col s4"
                        style={{ border: "1px solid #327AB7" }}
                        key={value}
                      >
                        <a
                          href={href}
                          style={style}
                          onClick={(e) => this.setActiveTab(e)}
                        >
                          {value}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              )}
              {this.state.commentCodesLoaded && (
                <>
                  {this.state.commentCodes.map((value) => {
                    const i = 0;
                    const id = value.typeName;
                    return id === activeTab ? (
                      <div
                        id={id}
                        key={value.typeName + i}
                        className="containerv2 tabBorder"
                        style={{
                          backgroundColor: "#fff",
                          padding: "10px",
                          border: "2px soild rgb(50, 122, 183)",
                          height: "300px",
                          overflow: "scroll",
                        }}
                      >
                        {value.codes.Compliment.length > 0
                          ? this.renderCommentCodes(
                            "Compliment",
                            value.codes.Compliment,
                            CommentCodeSelect.MoodColors.compliment
                          )
                          : null}
                        {value.codes.Suggestion.length > 0
                          ? this.renderCommentCodes(
                            "Suggestion",
                            value.codes.Suggestion,
                            CommentCodeSelect.MoodColors.suggestion
                          )
                          : null}
                        {value.codes.Neutral.length > 0
                          ? this.renderCommentCodes(
                            "Neutral",
                            value.codes.Neutral,
                            CommentCodeSelect.MoodColors.neutral
                          )
                          : null}
                      </div>
                    ) : null;
                  })}
                </>
              )}
            </section>
          </ModalContent>
          <ModalFooter>
            <Button
              type="submit"
              color="danger"
              onClick={() => this.setCommentCodes()}
            >
              <span>Select</span>
            </Button>
            <Button
              type="submit"
              color="white"
              onClick={() => this.cancelModal()}
            >
              <span>Cancel</span>
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }

  isHiddenColumn(prop: keyof IReview) {
    return this.state.hiddenProperties.indexOf(prop) >= 0;
  }

  toggleHiddenColumn(prop: keyof IReview) {
    const { hiddenProperties } = this.state;
    const indexOfProp = hiddenProperties.indexOf(prop);

    if (indexOfProp >= 0) {
      hiddenProperties.splice(indexOfProp, 1);
    } else {
      hiddenProperties.push(prop);
    }

    this.setState({ hiddenProperties });
    this.saveCachedColumns(hiddenProperties);
  }

  saveCachedColumns(columns: Array<keyof IReview>) {
    const columnsStr = JSON.stringify(columns);

    localStorage.setItem(
      SocialMediaDetailsContainer.SocialMediaDetailsContainerKey,
      columnsStr
    );
  }

  renderViewedColumn(record: IReview): JSX.Element {
    const text = record.viewed === "Yes" ? "Read" : "Unread";
    const isMuted = record.viewed === "Yes";

    return (
      <Tooltip text={text}>
        <FontAwesomeIcon
          icon="bookmark"
          verticalAlign="initial"
          muted={isMuted}
          fixedWidth
        />
      </Tooltip>
    );
  }

  openCoachingForm(record: IReview) {
    window.open("socialMediaCoachingform?id=" + record.id);

    this.markCoachingFormAsRead(record);
  }

  markCoachingFormAsRead(record: IReview) {
    const { records } = this.state;

    if (records.length > 0) {
      record.viewed = "Yes";
      const recordIndex = records.findIndex((v) => v.id === record.id);

      if (recordIndex >= 0) {
        records[recordIndex] = record;
        this.setState(this.state);
      }
    }
  }

  closeErrorMessage() {
    this.setState({ displayErrorMessage: false });
  }

  setActiveTab(e) {
    this.setState({ activeTab: $(e.currentTarget).text() });
  }

  findCode(shortLabel: string) {
    const { allCodes } = this.state;

    const code = allCodes.find((value) => {
      return value.shortLabel === shortLabel;
    });

    return code;
  }

  drawSelectedCode(shortLabel: string) {
    const code = this.findCode(shortLabel);
    const backgroundColor =
      code.mood === "Compliment"
        ? CommentCodeSelect.MoodColors.compliment
        : code.mood === "Suggestion"
          ? CommentCodeSelect.MoodColors.suggestion
          : CommentCodeSelect.MoodColors.neutral;
    return (
      <span
        style={{
          backgroundColor,
          color: "#1B3767",
          margin: "0 5px",
          padding: "5px",
        }}
      >
        {shortLabel + " (" + code.typeLabel + ")"}&nbsp;
        <a
          className="commentDetailsLink"
          style={{ color: "#1B3767" }}
          onClick={() => this.modifyStagedCodes(shortLabel)}
        >
          X
        </a>
      </span>
    );
  }

  renderCommentCodes(title: string, codes: ICommentCodeIndex[], color: string) {
    return (
      <div className="row">
        <h5 style={{ color }}>{title}</h5>
        {codes.map((code) => {
          return (
            <React.Fragment key={code.shortLabel + code.id}>
              <div className="col s6">
                <section style={{ padding: "10px", fontSize: "0.8rem" }}>
                  <a
                    className="commentDetailsLink"
                    style={{ color }}
                    onClick={(e) => this.handleCodeClick(e)}
                    title={code.longLabel}
                  >
                    {code.shortLabel}
                  </a>
                  &nbsp;{this.renderSelectedIcon(code.shortLabel)}
                </section>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  renderSelectedIcon(label) {
    const { stagingCodes } = this.state;
    if (stagingCodes && stagingCodes.includes(label)) {
      return <i className="fas fa-fw fa-check fa-lg fa-fw icon-green"></i>;
    }

    return null;
  }

  handleCodeClick(e) {
    const shortLabel = $(e.currentTarget).text();

    this.modifyStagedCodes(shortLabel);
  }

  modifyStagedCodes(shortLabel: string) {
    const { stagingCodes } = this.state;
    let displayErrorMessage = false;
    if (stagingCodes.includes(shortLabel)) {
      //NOTE: Splice value out of array
      const index = stagingCodes.findIndex((value) => {
        return value === shortLabel;
      });

      stagingCodes.splice(index, 1);
    } else {
      //NOTE: If codes < 3 then add else do nothing
      if (stagingCodes.includes(null)) {
        //NOTE: Splice value out of array
        const index = stagingCodes.findIndex((value) => {
          return value === null;
        });

        stagingCodes.splice(index, 1);
        stagingCodes.push(shortLabel);
      } else {
        if (stagingCodes.length < 6) {
          stagingCodes.push(shortLabel);
        } else {
          displayErrorMessage = true;
        }
      }
    }

    this.setState({ stagingCodes, displayErrorMessage });
  }

  cancelModal() {
    const { reviewInEditMode } = this.state;
    let { stagingCodes } = this.state;

    if (reviewInEditMode) {
      stagingCodes = [...reviewInEditMode.commentCodes];
    }

    this.setState({ stagingCodes }, () => this.toggleModal());
  }

  setCommentCodes() {
    const { reviewInEditMode, stagingCodes } = this.state;

    reviewInEditMode.commentCodes = stagingCodes;

    this.setState({ reviewInEditMode, stagingCodes: [] }, () => {
      this.toggleModal();
    });
  }

  submitReviewForUpdate(review: IReview) {
    const { reviewInEditMode } = this.state;
    this.setState({ isSubmittingUpdate: true });

    return updateReview(reviewInEditMode)
      .then(() => {
        const { records } = this.state;
        const commentDetailIndex = records.findIndex(
          (cd) => cd.id === review.id
        );
        review.commentCodes = reviewInEditMode.commentCodes;

        if (commentDetailIndex >= 0) {
          records[commentDetailIndex] = review;

          this.setState({ records });
        }
      })
      .finally(() =>
        this.setState({ isSubmittingUpdate: false, reviewInEditMode: null })
      );
  }

  setReviewInEditMode(reviewInEditMode: IReview | null) {
    let stagingCodes = [];
    if (reviewInEditMode) {
      //copy
      reviewInEditMode = { ...reviewInEditMode };
      stagingCodes = [...reviewInEditMode.commentCodes];
    }

    this.setState({ reviewInEditMode, stagingCodes });
  }

  toggleModal() {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  }

  updateReviewInEditMode(codes: Array<string | null>) {
    const { reviewInEditMode } = this.state;

    if (reviewInEditMode) {
      reviewInEditMode.commentCodes = codes;

      this.setState({ reviewInEditMode, stagingCodes: codes });
    }
  }

  renderStars(record: IReview): JSX.Element {
    const starRating = record.starRating;
    const stars = [];
    for (let i = 0; i < starRating; i++) {
      stars.push(
        <FontAwesomeIcon
          icon="star"
          color="yellow"
          key={record.id + "-" + i + "-star"}
        />
      );
    }
    return <section>{stars.map((s) => s)}</section>;
  }

  isSelected(record: IReview) {
    const { selectedReviewIds } = this.state;
    const selectedIndex = selectedReviewIds.indexOf(record.id);

    return selectedIndex >= 0;
  }

  toggleSelectedReview(record: IReview) {
    const { selectedReviewIds } = this.state;
    const selectedIndex = selectedReviewIds.indexOf(record.id);

    if (selectedIndex >= 0) {
      selectedReviewIds.splice(selectedIndex, 1);
    } else {
      selectedReviewIds.push(record.id);
    }

    this.setState({ selectedReviewIds });
  }

  renderBulkCheck(record: IReview): JSX.Element {
    const disableActions = false;
    const isSelected = this.isSelected(record);
    const isNotSelected = !isSelected;
    const icon = isSelected ? "check-square" : "square";
    const className = isNotSelected || disableActions ? "text-dark" : "";
    const iconElement = (
      <FontAwesomeIcon
        className={className}
        verticalAlign="initial"
        icon={icon}
        regular={isNotSelected && !disableActions}
      />
    );

    if (disableActions) {
      return <span>{iconElement}</span>;
    }

    return (
      <a
        href="javascript:void(0)"
        onClick={() => this.toggleSelectedReview(record)}
      >
        {iconElement}
      </a>
    );
  }

  renderStatusColumn(): JSX.Element {
    return <section>Coming Soon</section>;
  }

  selectNoneForReviews(): void {
    this.setState({ selectedReviewIds: [] });
  }

  selectAllReviews(): void {
    const { records } = this.state;
    const selectedReviewIds = records.map((r) => r.id);

    this.setState({ selectedReviewIds });
  }

  exportSelected(): void {
    throw new Error("Method not implemented.");
  }
}
